<template>
    <div>
        <div
            v-for="(type, index) in Object.keys(potentialContacts)"
            :key="index"
            class="flex-col items-center hidden sm:flex"
        >
            <span class="text-xs font-medium my-2">{{ type }}</span>
            <div class="flex flex-col items-center gap-2">
                <div
                    v-for="(contactGroup, index) in potentialContacts[type].slice(0, 6)"
                    :key="index"
                    class="cursor-pointer"
                >
                    <template v-if="contactGroup.contacts.length === 1">
                        <MutliContactNameIcon
                            :data="contactGroup.contacts || []"
                            badgeClass="!bg-[#FF5EAB] z-0"
                            :isLarge="true"
                            :show-interactions="true"
                            :is-show="false"
                            @handleClick="() => emits('handleContactClick', contactGroup)"
                        />
                    </template>
                    <template v-else>
                        <GroupIcon
                            :contacts="contactGroup.contacts"
                            @handleClick="() => emits('handleContactClick', contactGroup)"
                        />
                    </template>
                </div>
            </div>
        </div>

        <div class="mt-2">
            <app-dropdown>
                <app-dropdown-list :gray="true" placement="top">
                    <template #dropdownBtn>
                        <div
                            class="border rounded-full bg-white h-12 sm:h-10 w-12 sm:w-10 flex justify-center items-center text-gray-600 text-base mx-auto"
                        >
                            <span class="hidden sm:block">+{{ remainingContacts }}</span>
                            <fa
                                :icon="['fal', 'message-plus']"
                                class="text-gray-300 text-xl cursor-pointer block sm:hidden"
                            />
                        </div>
                    </template>

                    <template #content="{ hide }">
                        <div
                            v-for="(type, index) in Object.keys(potentialContacts)"
                            :key="index"
                            class="flex flex-col px-2"
                        >
                            <p class="text-xs my-2 border-b text-gray-400 font-bold pb-2">
                                RELATED <span class="uppercase">{{ type }}</span> CHATS
                            </p>
                            <div class="flex flex-col gap-2">
                                <ul class="list-disabled-styling">
                                    <li
                                        v-for="(contactGroup, index) in getPotentialContacts(type)"
                                        :key="index"
                                        class="cursor-pointer !not-italic"
                                        @click="
                                            () => {
                                                hide();
                                                emits('handleContactClick', contactGroup);
                                            }
                                        "
                                    >
                                        <MutliContactNameIcon
                                            :data="contactGroup.contacts || []"
                                            badgeClass="!bg-[#FF5EAB] z-0"
                                            :isLarge="true"
                                            :is-show="true"
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </template>
                </app-dropdown-list>
            </app-dropdown>
        </div>

        <!-- <span class="tooltip hidden sm:block"
            >Related <br />
            chats</span
        > -->
    </div>
</template>

<script setup>
import MutliContactNameIcon from "@/components/contacts/MutliContactNameIcon.vue";
import GroupIcon from "@/components/contacts/GroupIcon.vue";
import AppDropdown from "@/components/dropdown/AppDropdown.vue";
import AppDropdownList from "@/components/dropdown/AppDropdownList.vue";
import { useScreenSize } from "@/composables/globals";
import { computed } from "vue";

const emits = defineEmits(["handleContactClick"]);

const props = defineProps({
    potentialContacts: {
        type: Object,
        default: () => ({}),
    },
});

const remainingContacts = computed(() => {
    let count = 0;
    Object.keys(props.potentialContacts).forEach((type) => {
        props.potentialContacts[type].forEach((_, index) => {
            if (index > 5) count++;
        });
    });
    return count;
});

const screenSizex = useScreenSize();

// [info]: methods
const getPotentialContacts = (type) => {
    return screenSizex.screenSize.value === "xs"
        ? props.potentialContacts[type]
        : props.potentialContacts[type].slice(6);
};
</script>

<style scoped>
.tooltip {
    position: fixed;
    bottom: 15px;
    right: 0;
    text-align: center;
    font-size: 12px;
    background: #fff;
    padding: 5px 8px;
    border-radius: 5px;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
    pointer-events: none;
    transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    margin-top: 100px;
    border: 0.5px solid gainsboro;
    margin-inline: 6px;
}

.tooltip::before {
    position: absolute;
    content: "";
    height: 8px;
    width: 8px;
    background: #fff;
    top: -5px;
    left: 50%;
    transform: translate(-50%) rotate(45deg);
    transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    border-top: 0.5px solid gainsboro;
    border-left: 0.5px solid gainsboro;
}
</style>
